/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useEffect, useState, useContext } from 'react'
import UserContext from './UserContext'
import axios from '../config/axios'
interface SectionContextProps {
  section: string
  setSection: (section: string) => void
  stockSection: string
  setStockSection: React.Dispatch<React.SetStateAction<string>>
  accessesSection: string
  setAccessesSection: React.Dispatch<React.SetStateAction<string>>
  certificatesSection: string
  setCertificatesSection: React.Dispatch<React.SetStateAction<string>>
  productionFlowSection: string
  setProductionFlowSection: React.Dispatch<React.SetStateAction<string>>
  refreshSection: boolean
  setRefreshSection: React.Dispatch<React.SetStateAction<boolean>>
  routerSection: string
  setRouterSection: React.Dispatch<React.SetStateAction<string>>
  permissions: string[]
}

const SectionContext = createContext<SectionContextProps>({
  section: '',
  setSection: () => {},
  stockSection: '',
  setStockSection: () => {},
  accessesSection: '',
  setAccessesSection: () => {},
  certificatesSection: '',
  setCertificatesSection: () => {},
  productionFlowSection: '',
  setProductionFlowSection: () => {},
  refreshSection: false,
  setRefreshSection: () => {},
  routerSection: '',
  setRouterSection: () => {},
  permissions: []
})

export default SectionContext

export const SectionProvider: React.FC<any> = ({ children }) => {
  const { user, setUser } = useContext(UserContext)
  const [section, setSection] = useState<string>('orders')
  const [stockSection, setStockSection] = useState<string>('stock')
  const [accessesSection, setAccessesSection] = useState<string>('accesses')
  const [certificatesSection, setCertificatesSection] =
    useState<string>('certificates')
  const [ routerSection, setRouterSection ] = useState<string>('freight')
  const [permissions, setPermissions] = useState<string[]>([])
  const [productionFlowSection, setProductionFlowSection] =
    useState<string>('services')
  const [refreshSection, setRefreshSection] = useState<boolean>(false)

  useEffect(() => {
    console.log('📁 [SECTION-CONTEXT] useEffect trigger:', {
      hasUser: !!user,
      userProfileId: user?.profileId,
      permissionsLength: permissions.length,
      shouldFetch: !!(user && user.profileId && permissions.length === 0)
    })
    
    if (user && user.profileId && permissions.length === 0) {
      console.log('🔄 [SECTION-CONTEXT] Iniciando busca de permissões para profileId:', user.profileId)
      const fetchPermissions = async () => {
        const perms = await getPermissions()
        console.log('🎯 [SECTION-CONTEXT] Permissões retornadas:', perms)
        if (perms && perms.length > 0) {
          setPermissions(perms)
          setSection(perms[0])

          console.log('✅ [SECTION-CONTEXT] Permissões definidas no contexto:', perms)
          const updatedUser = { ...user, permissions: perms }
          console.log('Atualizando usuário com permissões:', updatedUser)
          try {
            if (setUser) setUser(updatedUser)
          } catch (e) {
            console.warn('Não foi possível atualizar user via setUser:', e)
          }
        } else {
          console.log('⚠️ [SECTION-CONTEXT] Nenhuma permissão encontrada')
          setPermissions([])
        }
      }
      fetchPermissions()
    }
  }, [user?.profileId, permissions.length])



  const getPermissions = async () => {
    console.log('🚀 [SECTION-CONTEXT] Fazendo requisição para profileId:', user?.profileId)
    try {
      const response = await axios(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/profile/find/${user.profileId}?_t=${Date.now()}`
      )

      console.log('📋 [SECTION-CONTEXT] Resposta da API:', {
        status: response.status,
        hasData: !!response.data,
        hasPermissions: !!(response.data && response.data.permissions),
        permissions: response.data?.permissions
      })

      if (response.data && response.data.permissions) {
        const rawPerms = response.data.permissions
        let normalized: string[] = []
        if (Array.isArray(rawPerms)) {
          normalized = rawPerms
            .map((p: any) => (typeof p === 'string' ? p : p?.name || p?.permission || ''))
            .filter((p: string) => !!p)
        }
        console.log('Permissões carregadas do perfil (normalizadas):', normalized)
        localStorage.setItem(`permissions_${user.profileId}`, JSON.stringify(normalized))
        return normalized
      } else if (response.status === 304) {
        console.log('Resposta 304 - usando cache, tentando buscar do localStorage')
        const cachedPermissions = localStorage.getItem(`permissions_${user.profileId}`)
        if (cachedPermissions) {
          const parsed = JSON.parse(cachedPermissions)
          console.log('Permissões do cache:', parsed)
          return parsed
        }
      }
    } catch (error: any) {
      console.log('❌ [SECTION-CONTEXT] Erro ao buscar perfil:', error.response?.status, error.message)
      
      // Tentar buscar do cache em caso de erro
      const cachedPermissions = localStorage.getItem(`permissions_${user.profileId}`)
      if (cachedPermissions) {
        console.log('Usando permissões do cache devido ao erro:')
        const parsed = JSON.parse(cachedPermissions)
        return parsed
      }
    }
    console.log('⚠️ [SECTION-CONTEXT] Retornando array vazio - sem permissões')
    return []
  }

  return (
    <SectionContext.Provider
      value={{
        section,
        setSection,
        stockSection,
        setStockSection,
        accessesSection,
        setAccessesSection,
        certificatesSection,
        setCertificatesSection,
        routerSection,
        setRouterSection,
        productionFlowSection,
        setProductionFlowSection,
        refreshSection,
        setRefreshSection,
        permissions,
      }}
    >
      {children}
    </SectionContext.Provider>
  )
}
